export default __webpack_public_path__ + "assets/a23be057f69bb95f6e8d65d424398e00.svg";